

const dmNhomDVKTColumns = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (value, record, index) => (index + 1),
    width: "2%"
  },
  { title: "Mã", dataIndex: "id", show: true, align: "left", width: "12%"},
  { title: "Tên", dataIndex: "tenNhomDichVu", show: true, align: "left", width: "24%"},
  { title: "Mô tả", dataIndex: "moTa", show: true, align: "left"},
  { title: "Thao tác", dataIndex: "action", align: 'center', width: "8%"}
]

const dmLoaiDVKTColumns = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (value, record, index) => (index + 1),
    width: "2%"
  },
  { title: "Mã", dataIndex: "maLoaiDichVuKyThuat", show: true, align: "left", width: "12%"},
  { title: "Tên", dataIndex: "tenLoaiDichVuKyThuat", show: true, align: "left", width: "24%"},
  { title: "Mô tả", dataIndex: "moTa", show: true, align: "left"},
  { title: "Thao tác", dataIndex: "action", align: 'center', width: "8%"}
]

const dmTrangThaiDVKTColumns = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (value, record, index) => (index + 1),
    width: "2%"
  },
  { title: "Mã", dataIndex: "maTTDichVuKyThuat", show: true, align: "left", width: "12%" },
  { title: "Tên", dataIndex: "tenTTDichVuKyThuat", show: true, align: "left", width: "24%" },
  { title: "Mô tả", dataIndex: "moTa", show: true, align: "left" },
  { title: "Thao tác", dataIndex: "action", align: 'center', width: "8%"}
]

export {
  dmNhomDVKTColumns,
  dmLoaiDVKTColumns,
  dmTrangThaiDVKTColumns
}